<template>
  <v-dialog
    v-model="dialog"
    width="634px">
    <div class="dialog-container">
      <span class="title">Underwriting Questions</span>
      <div class="p-class">
        <!--        <span class="bold"> Please select if the customer meets all the following requirements </span>-->
        <span class="bold">You are assisting a 3rd party to pre-fill information in
          <span class="width-20">
            <v-select
              v-model="cust_typ"
              :disabled="disabledType"
              :list="userTypeOptions"></v-select></span>
        </span>
        <span class="bold">capacity</span>
        <!-- <span
          v-for="(item, index) in localAllOptions.underwriting"
          :key="index">
          {{ item.name }}
        </span> -->
        <v-checkbox-group
          v-model="underwriting"
          :block="true"
          :list="underList" >
          <template #default="{ item }">
            <span :class="{'special-waring':item.type=='clause'}">{{item.name}}</span>
          </template>
        </v-checkbox-group>
        <div
          v-for="(item,index) in showUnderList"
          :key="'clause'+index">
          <el-checkbox
            v-model="select"
            disabled>
            <template>
              <span :class="{'special-waring':item.type=='clause'}">{{item.name}}</span>
            </template>
          </el-checkbox>
        </div>
      </div>

      <!--      <v-checkbox-group-->
      <!--        v-model="underwriting"-->
      <!--        :block="true"-->
      <!--        disabled-->
      <!--        :list="showUnderList" >-->
      <!--        <template #default="{ item }">-->
      <!--          <span :class="{'special-waring':item.type=='clause'}">{{item.name}}</span>-->
      <!--        </template>-->
      <!--      </v-checkbox-group>-->

      <div class="flex-sb">
        <div>
          <v-button @click="dialog = false">Cancel</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            @click="handlerConfirm">Confirm</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'BuyPolicyTipsDialog',
  mixins: [MixinOptions],
  props: {
    classId: {
      type: [String, Number],
      default: 14
    },
    underList:{
      type:Array,
      default:()=>([])
    },
    showUnderList:{
      type:Array,
      default:()=>([])
    }
  },
  data() {
    return {
      dialog: false,
      underwriting: [],
      select:true,
      onlyPersonal: [12, 13, 14, 16, 18, 22],
      onlyCompany: [15],
      cust_typ:''
    }
  },
  computed: {
    ...mapState('account', ['customerId']),
    localAllOptions(){
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`] || {}
      }
    },
    disabledType() {
      const productId = Number(this.productId)
      if(this.customerId) return true
      if(this.onlyPersonal.includes(productId)) return true
      if(this.onlyCompany.includes(productId)) return true
      return false
    },
  },
  watch: {
    underList: {
      immediate: true,
      deep: true,
      handler(val, old) {
        if(val && val.length > 0) {
          let arr = []
          val.some(item => {
            const { id } = item
            arr.push(id)
          })
          this.underwriting = arr
        }
      }
    }
  },
  mounted() {
    if(this.onlyPersonal.includes(Number(this.productId))) {
      this.cust_typ = 1
    }
    else if(this.onlyCompany.includes(Number(this.productId))) {
      this.cust_typ = 2
    }
    else this.cust_typ = 1
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerConfirm() {
      // 處理問題， 檢查是否全選
      const { underwriting = [] } = this.localAllOptions
      const options = JSON.parse(JSON.stringify(this.underList))
      const value = this.underwriting
      if(options.length === value.length) {
        this.dialog = false
        this.$emit('confirm','',this.customerId?'':this.cust_typ)
      }
      else {
        // 整合數據
        const underwriting = options.reduce((result, item) => {
          const { id } = item
          let answer = 0
          if(value.includes(id)) {
            answer = 1
          }
          result.push({
            ...item,
            answer
          })
          return result
        }, [])
        this.dialog = false
        this.$emit('confirm', underwriting,this.customerId?'':this.cust_typ)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    .dialog-container {
      padding: 15px;
      font-size: 16px;
      color: #616266;
      .bold {
          font-weight: bold;
        display: flex!important;
        align-items: center;
      }
      .p-class {
          padding: 10px 0;
          span {
              display: block;
              padding-bottom: 10px;
              word-break: break-word;
          }
      }
      .special-waring{
        color: #d73a49;
      }
    }
    .width-20{
      width: 150px;
      font-weight: 400;
      padding-bottom: 0px!important;
      margin-left: 10px;
    }
</style>
